export default __webpack_public_path__ + "static/media/banner.04f1dbfd.jpg";